import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { useAccountSlug } from './use-account-slug';

export function useNavigationPaths() {
  const accountSlug = useAccountSlug();
  const { commitHash } = useParams();

  return useMemo(() => {
    const basePrefix = commitHash
      ? `/${commitHash}/${accountSlug}`
      : `/${accountSlug}`;

    return {
      dashboardPath: `${basePrefix}/dashboard`,
      allOpeningsPath: `${basePrefix}/openings`,
      allCampaignsPath: `${basePrefix}/campaigns`,
      postJobPath: `${basePrefix}/post-job`,
      sourceSettingsPath: `${basePrefix}/settings`,
    };
  }, [commitHash, accountSlug]);
}
